import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';
import { Badge, Icon } from 'corso-admin-ui';
import { formatter } from 'corso-web-lib';

/** How a value moved against the period before. */
export const ChangeBadge = ({ change }: { change: number | null }) => {
  if (change === null || change === 0) return null;
  const isUp = change >= 0;

  return (
    <Badge
      variant={isUp ? 'success' : 'danger'}
      className="font-medium tabular-nums"
    >
      <Icon icon={isUp ? faArrowUp : faArrowDown} className="size-2.5" />
      <span className="sr-only">{isUp ? 'Up' : 'Down'} </span>
      {formatter.percent(Math.abs(change), false, {
        minimumSignificantDigits: undefined,
        maximumSignificantDigits: undefined,
        maximumFractionDigits: 1,
      })}
    </Badge>
  );
};
